import { ROUTES } from "../../constant/common.constant";
import { Box } from "../../common/components";
import { Typography } from "@mui/material";
import { palette } from "../../styles/theme";
import { useTranslation } from "react-i18next";
import {
  generatePath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import DownloadTechpackButton from "../../components/AdminTechpack/DownloadTechpackButton";

export const ADMIN_TOOLBAR_HEIGHT = 79;

const styles = {
  container: {
    display: "flex",
    gap: "8px",
  },
  section: {
    paddingLeft: "12px",
    paddingRight: "12px",
    paddingTop: "8px",
    paddingBottom: "8px",
    borderRadius: "100px",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "2px",
    display: "inline-flex",
    cursor: "pointer",
    color: palette.grey.primary,
    "&:hover": {
      background: palette.blue.paleEffect,
      "& span": {
        color: palette.blue.secondary,
      },
    },
  },
  sectionActive: {
    background: palette.blue.pale,
    "& span": {
      color: palette.blue.secondary,
    },
    "&:hover": {
      background: palette.blue.pale,
    },
  },
};

interface AdminToolbarProps {
  isVisible: boolean;
  hideDownloadButton?: boolean;
}

const AdminToolbar = ({
  isVisible,
  hideDownloadButton = false,
}: AdminToolbarProps) => {
  const { t } = useTranslation();
  const { orderId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const sections = [
    {
      title: t("admin.all_orders"),
      path: generatePath(ROUTES.ADMIN_ALL_ORDERS, { orderId }),
    },
    {
      title: t("admin.order"),
      path: generatePath(ROUTES.ADMIN_ORDER, { orderId }),
    },
    {
      title: t("admin.techpack"),
      path: generatePath(ROUTES.ADMIN_TECHPACK_ORDER, { orderId }),
    },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        pt: "24px",
        pb: "24px",
        pl: "24px",
        width: "100%",
        zIndex: 1000,
        display: "flex",
        gap: "8px",
        height: ADMIN_TOOLBAR_HEIGHT,
        background: palette.grey.lightBackground,
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.3s ease-in-out",
        justifyContent: "space-between",
        displayPrint: "none",
      }}
    >
      <Box>
        {sections.map((section) => (
          <Box
            key={section.title}
            sx={{
              ...styles.section,
              ...(pathname === section.path && styles.sectionActive),
            }}
            onClick={() => {
              navigate(section.path);
            }}
          >
            <Typography variant="textSmBold">{section.title}</Typography>
          </Box>
        ))}
      </Box>
      {!hideDownloadButton && (
        <Box pr={"24px"}>
          <DownloadTechpackButton />
        </Box>
      )}
    </Box>
  );
};

export default AdminToolbar;
